<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
        분석 요청
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WSFinder</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Report</a>
          </li>
      </ul>
    </div>
    <b-card>
      <b-row>
        <b-col>
          파일 업로드
        </b-col>
      </b-row>
      <hr>
      <b-col md="12" style="text-align:center;font-size:15pt;">
        <label class="btn btn-xs btn-info" style="width:90%;height:45px;">
          <b-row>
            <b-form-file v-model="file" @change="bs_file" v-show="false"></b-form-file>
          </b-row>
          파일 선택
        </label>
      </b-col>
      <hr>
      <b-row>
        <b-col md="12" class="text-center">
          의심스러운 웹쉘 파일을 신고 할 수 있습니다. <br>
          확인 하고 결과를 메일로 회신드립니다.
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <b-row>
        <b-col>
          전송 대기 목록
        </b-col>
      </b-row>
      <hr>
      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found" class="table-responsive table_add" :items="files" :fields="fields_ko">
        <template slot="index" slot-scope="row">{{row.index+1}}</template>
        <template slot="name" slot-scope="row">{{row.item.name}}</template>
        <template slot="description" slot-scope="row">
          <input type="text" placeholder="description" v-model="file.description" style="width:100%;">
        </template>
        <template slot="size" slot-scope="row">{{row.item.size}}</template>
        <template slot="func" slot-scope="row">
          <b-btn @click="remove(row.index)" size="sm" variant="outline-danger">삭제</b-btn>
          <b-btn @click="send(row.index)" size="sm" variant="outline-primary">전송</b-btn>
        </template>
      </b-table>
    </b-card>
    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
